/**
 * User: Rob Richard
 * Date: 3/17/15
 * Time: 10:56 AM
 */

'use strict';

var SoaModel = require('bunsen/models/SoaModel');
var Token = module.exports = SoaModel.extend();
var root = typeof window === 'undefined' ? global : window;

root.bunsen = root.bunsen || {};
module.exports = root.bunsen.Token = Token;

var _ = require('underscore');
var ends = require('dibs-endpoints');

_.extend(Token.prototype, {
    fetchClientToken: function () {
        return this.fetch({
            url: ends.paymentProviderClientToken()
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/Token.js
// module id = 134
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56